export default __webpack_public_path__ + "static/media/background.ff2b8383.jpg";